import { Header } from '@/components/Generic'
import { observer } from 'mobx-react'
import { Illustration } from '@/components/Illustration/Illustration'

interface SuccessPageProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  trans: any
  isSes?: boolean
}

export const SuccessCongratulationsPage = observer(({ trans, isSes }: SuccessPageProps) => {
  return (
    <div className="page-container mobile-m-0">
      <>
        <Illustration type="sign-document-success" />
        <Header>{trans.header}</Header>
        <p className="generic__paragraph-centered">{trans.message}</p>

        {!isSes && (
          <>
            <p className="generic__paragraph-centered m-0-0-15">
              <strong>{trans.anyQuestions}</strong>
            </p>
            <p className="generic__paragraph-centered m-0-0-15">{trans.anyQuestionsDescription}</p>
            <div className="generic__spacer h-15" />
          </>
        )}
      </>
    </div>
  )
})
